/**
 * Admin 사이트 > 메인 영상 CRUD. 라우트 admin.php site.main-videos 와 동기화.
 */
import { Logger } from "../../utils/Logger";

function noop(controller: string, action: string): void {
    Logger.debug(`${controller}.${action} (no-op)`);
}

const CTRL_TAG = "AdminMainVideoController";

export const AdminMainVideoController = {
    index(): void {
        noop(CTRL_TAG, "index");
    },
    create(): void {
        noop(CTRL_TAG, "create");
    },
    store(): void {
        noop(CTRL_TAG, "store");
    },
    edit(): void {
        noop(CTRL_TAG, "edit");
    },
    update(): void {
        noop(CTRL_TAG, "update");
    },
    destroy(): void {
        noop(CTRL_TAG, "destroy");
    },
};
